/* unplugin-vue-components disabled */import script from "./UploadId.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadId.vue?vue&type=script&setup=true&lang=js"

import "./UploadId.vue?vue&type=style&index=0&id=5949429a&lang=less"

const __exports__ = script;

export default __exports__